import React,{Component} from 'react';

import {FormGroup,Button} from 'react-bootstrap';
// import SwitchButton from 'react-switch-button';

import SelectWrap from '../../../../components/SelectWrap';


class MessageSendForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            messageID: null,
            defaultMessageID: null,
            segments: null,
            sendToAll: false
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleFieldChange(event) {
        const {target} = event;
        const {name,type} = target;
        const value = type === 'checkbox' ? target.checked : target.value;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        let form = this.state;

        form = Object.keys(form).reduce((obj, param) => {
            let value = form[param];
            if(value) {
                obj[param] = value;
            }

            return obj;
        },{});

        this.props.onSubmit(form);
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <SelectWrap
                    values={this.props.messages}
                    label="Message:"
                    name="messageID"
                    onChange={this.handleFieldChange}
                    value={this.state.messageID}
                />
                <SelectWrap
                    values={this.props.defaultMessages}
                    label="Default Message:"
                    name="defaultMessageID"
                    onChange={this.handleFieldChange}
                    value={this.state.defaultMessageID}
                />
                <SelectWrap
                    values={this.props.segments}
                    label="Segments:"
                    name="segments"
                    onChange={this.handleFieldChange}
                    value={this.state.segments}
                    multi={true}
                />
                <FormGroup>
                    {/*<SwitchButton*/}
                        {/*name="sendToAll"*/}
                        {/*theme="rsbc-switch-button-flat-square"*/}
                        {/*labelRight="Send to All"*/}
                        {/*onChange={this.handleFieldChange}*/}
                    {/*/>*/}
                </FormGroup>

                {/*<FieldGroup*/}
                    {/*name="vibration"*/}
                    {/*label="Vibration:"*/}
                    {/*placeholder="[300,200,300,200,300]"*/}
                    {/*onChange={this.handleFieldChange}*/}
                    {/*value={this.state.vibration}*/}
                {/*/>*/}

                <Button type="submit" bsStyle="primary">Send</Button>
            </form>
        );
    }
}

export default MessageSendForm;


// WEBPACK FOOTER //
// ./src/scenes/Send/components/MessageSendForm/index.js